import Vue, { PropType } from "vue";
import { Client } from "../../definitions";

export const ClientBox = Vue.extend({
    template: require("./client.html"),
    props: {
        client: Object as PropType<Client>,
    },
});
